import React, { Component } from 'react';
import './index.scss';
import { login } from '../../services/Api/User/UserService';
import { Errors } from '../../constants/errors';
import { BONUS_PRICE, PUBLIC_ROUTE_REGEX } from '../../constants/defaults';
import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import LoginErrorPopup from '../Header/LoginErrorPopup.jsx';
import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';
import { AuthContext } from '../../Contexts';
import toast from '../Toaster/toast';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Email: '',
      Password: '',
      EmailError: '',
      PasswordError: '',
      showLoader: false,
      showNotification: false,
      showServerError: false,
      notificationError: '',
      hidePassword: true,
      showToaster: false,
      showThankyouMessage: false,
      showErrorMsg: false,
      redirectUrl: '',
      redirectState: ''
    };
    this.eyeRef = React.createRef();
    if (this.props.userName) {
      this.props.history.push('/');
      window.onpopstate = () => {
        this.props.history.go(1);
      };
    }
  }

  static contextType = AuthContext;

  componentDidMount() {
    const urlParams = new URLSearchParams(
      typeof window !== 'undefined' && window.location.search
    );
    if (urlParams && urlParams.has('thankyou')) {
      this.setState({
        showThankyouMessage: true
      });
    }
    if (urlParams && urlParams.has('redirect_uri')) {
      this.setState({
        redirectUrl: urlParams.get('redirect_uri'),
        redirectState: urlParams.get('state')
      });
    }
  }

  toggleForgotPassword() {
    let isEs = _.isEqual(this.props.i18n.language, 'es');
    let url = isEs ? '/es/restablecer-contrasena' : '/forgot-password';
    localStorage.setItem('backPath', this.props.location.pathname);
    window.location.assign(url);
  }

  onInputChange(event = { target: { name: '', value: '' } }) {
    const { name, value } = event.target;
    let newState = {};
    newState[name] = value;
    this.setState(Object.assign({}, this.state, newState));
  }

  hideNotification(
    event = {
      preventDefault() {}
    }
  ) {
    event.preventDefault();
    this.setState({ showNotification: false });
  }
  onInputKeyUp(event = { target: { name: '', value: '' } }) {
    const { name, value } = event.target;
    let newState = {};
    newState[name] = value;
    newState[`${name}Error`] = '';
    if (name === 'Password') {
      if (_.isEmpty(value.trim())) {
        newState[`${name}Error`] = Errors['Required'];
      }
    } else if (name === 'Email') {
      if (!_.validateEmail(value)) {
        newState[`${name}Error`] = _.isEmpty(value.trim())
          ? Errors['Required']
          : Errors['Email'];
      }
    }
    this.setState(Object.assign({}, this.state, newState));
  }

  setUserPoints = loginResponse => {
    this.props.setUserPoint(loginResponse);
  };

  async submit(event = { preventDefault() {} }) {
    const { Email, Password } = this.state;
    const { isFromHeader, location, history } = this.props;
    const { t } = this.props;
    event.preventDefault();
    this.setState({ showServerError: false });
    if (!_.validateEmail(Email) || _.isEmpty(Password.trim())) {
      let newState = {};
      if (!_.validateEmail(Email)) {
        newState.EmailError = _.isEmpty(Email.trim())
          ? Errors['Required']
          : Errors['Email'];
      }
      if (_.isEmpty(Password.trim())) {
        newState.PasswordError = Errors['Required'];
      }
      this.setState(Object.assign({}, this.state, newState));
      return;
    }
    _.triggerGTMVirtualPageViewEvent({
      event: 'signInSubmitClick',
      formId: 'sign in',
      clickText: 'Sign in'
    });
    // Submit data only if form valid
    if (Email !== '' && Password !== '' && this.form.checkValidity()) {
      await this.setState({ showLoader: true });
      const loginData = {
        email: Email,
        password: Password,
        tenantId: 0,
        invalidateSessions: this.state.showThankyouMessage
      };
      try {
        const loginResponse = await login(loginData);
        if (loginResponse && loginResponse.status === 200) {
          /*
         after login set user data and call api to get user points
       */
          this?.context?.setUserData(loginResponse?.data);
          this.props.setUser(loginResponse?.data);
          this.setUserPoints(loginResponse);
          if (loginResponse.data.confirmationRequired) {
            this.props.history.push('/update-user');
          } else {
            if (isFromHeader) {
              this.setState({
                showLoader: false
              });
              if (this.props.redirectUri) this.props.hideSignInOpenFlashModal();
              else {
                _.triggerGTMVirtualPageViewEvent({
                  event: 'signInSuccess',
                  formId: 'sign in'
                });
                if (this.props.location.pathname.match(PUBLIC_ROUTE_REGEX)) {
                  history.push(_.withLocale(this.props.i18n.language, '/'));
                } else {
                  // this.setUserPoints(loginResponse);
                  //window.location.reload();
                }
              }
            } else if (!_.isEmpty(this.state.redirectUrl)) {
              window.open(
                decodeURI(
                  this.state.redirectUrl +
                    '?code=' +
                    loginResponse.data.sessionId +
                    '&state=' +
                    this.state.redirectState
                ),
                '_self'
              );
            } else if (location && location.state) {
              history.push(`${location.state.prevPath}`);
            } else {
              history.push(_.withLocale(this.props.i18n.language, '/'));
            }
          }
          toast.success(t('Logged In'));
        }
      } catch (err) {
        if (
          err.response &&
          err.response.status &&
          err.response.status === 401
        ) {
          if (err.response.data.error === 'VerificationRequired') {
            this.setState({
              showLoader: false
            });
            isFromHeader ? this.props.showHeaderText() : this.showHeaderText();
            return;
          }
        }
        if (
          err.response &&
          err.response.status &&
          err.response.status === 403
        ) {
          if (err.response.data.error === 'AuthenticationFailed') {
            this.setState({
              showLoader: false,
              showNotification: false,
              notificationError: t('Incorrect username or password.'),
              showServerError: true
            });
            return;
          }
          if (err.response.data.error === 'UserAccountLocked') {
            this.setState({
              showLoader: false,
              showNotification: false,
              notificationError: t('User account lock error text'),
              showServerError: true
            });
            return;
          }
        }
        if (err.response && err.response.data) {
          this.setState({
            showLoader: false,
            showNotification: false,
            notificationError: err.response.data.message,
            showServerError: true
          });
          return;
        }
        this.setState({
          showLoader: false,
          showNotification: false,
          notificationError: err.message,
          showServerError: true
        });
      }
    }
  }

  togglePasswordVisibility() {
    this.eyeRef.current && this.eyeRef.current.focus();
    this.setState({
      hidePassword: !this.state.hidePassword
    });
  }

  hideToaster = () => {
    this.setState({
      showToaster: false,
      showErrorMsg: false
    });
  };

  showHeaderText = () => {
    this.setState({
      showErrorMsg: true
    });
  };

  changeLanguage = lng => {
    let newUrl =
      _.withLocale(lng, this.props.location.pathname) +
      (!_.isEmpty(this.props.location.search)
        ? this.props.location.search
        : '');
    //window.location = newUrl;
    return newUrl;
  };

  render() {
    const {
      showLoader,
      showNotification,
      notificationError,
      showToaster,
      toasterMessage,
      showServerError,
      EmailError,
      PasswordError,
      hidePassword,
      Email,
      Password,
      showThankyouMessage,
      showErrorMsg
    } = this.state;
    const { location, isFromHeader } = this.props;
    const pagePath = location && location.state ? location.state.prevPath : '/';
    const { t, i18n } = this.props;
    let lang = i18n.language;
    return (
      <div className="search-disabled form-bg">
        {!isFromHeader && (
          <Helmet>
            <meta
              name="ROBOTS"
              content="NOINDEX, FOLLOW, NOSNIPPET, NOODP, NOYDIR"
            />
            <link
              rel="alternate"
              href="https://www.singlecare.com/login"
              hrefLang="en-us"
            />
            <link
              rel="alternate"
              href="https://www.singlecare.com/es/iniciar-sesion"
              hrefLang="es-us"
            />
          </Helmet>
        )}
        {showErrorMsg && <LoginErrorPopup hideToaster={this.hideToaster} />}
        <section
          id="login-form"
          className="login login-form sc-registration-v2"
        >
          <div className={i18n.language === 'es' ? 'spanish' : 'english'}>
            <div className="languages innerLanguages">
              {i18n.language === 'en' ? (
                <a
                  className="spanishBtn whiteFocus"
                  href={this.changeLanguage('es')}
                >
                  Español
                </a>
              ) : (
                <a
                  className="englishBtn whiteFocus"
                  href={this.changeLanguage('en')}
                >
                  English
                </a>
              )}
            </div>
          </div>
          {showNotification && (
            <div
              className={`notification ${showNotification ? 'visible' : ''}`}
            >
              {notificationError}
              <span
                className="close-button"
                onClick={this.hideNotification.bind(this)}
              >
                ×
              </span>
            </div>
          )}
          {_.isEmpty(this.state.redirectUrl) && (
            <header>
              <Link to="/" className="sc-logo desktop-only">
                <img src="/content/images/header/sc-logo.svg" alt="sc-logo" />
              </Link>
              <Link to={pagePath} className="backToPage mobile-only">
                {t('Back')}
              </Link>
              <Link to={pagePath} className="closeHeader mobile-only">
                <LazyLoadImage
                  src="/content/images/icons/close.svg"
                  alt=""
                  width="25px"
                  aria-hidden="true"
                />
              </Link>
            </header>
          )}
          {showThankyouMessage && (
            <div className="resetPasswordMessage textCenter">
              <h1>{t('Thanks!')}</h1>
              <p>
                {t('Your password has been reset.')}&nbsp;
                <br className="mobile-only" />
                {t('Please sign in below.')}
              </p>
            </div>
          )}
          <div className="login--form">
            {!showThankyouMessage && (
              <div>
                {_.isEmpty(this.state.redirectUrl) && (
                  <div>
                    <div className="loginHeader mobile-only">
                      {t('Sign in to your account')}
                    </div>
                  </div>
                )}
                {!_.isEmpty(this.state.redirectUrl) && (
                  <div>
                    <h2 className="subHeading">
                      {t('You need to sign in to access')}&nbsp;
                      <span className="spanishNone">{t('Home delivery')}</span>.
                    </h2>
                  </div>
                )}
              </div>
            )}
            {showServerError && (
              <span
                id="emailPasswordError"
                className="label-error"
                role="alert"
              >
                {_.isEmpty(notificationError)
                  ? t(
                      "We don't recognize that account information. Please try entering it again."
                    )
                  : notificationError}
              </span>
            )}
            <form ref={form => (this.form = form)} autoComplete="on">
              <div className="sc-form-row sc-form-row--email">
                <label id="login-email" className="sc-form__label">
                  {t('Email')}
                </label>
                <input
                  className={`themeFocus menuComponent sc-form__text sc-form__icon-text sc-form__icon--mail ${
                    this.state.EmailError &&
                    'sc-form__text sc-form__icon-text sc-form__icon--mail invalid'
                  }`}
                  data-validate="required,email"
                  id="Email"
                  name="Email"
                  placeholder={t('example@domain.com')}
                  type="email"
                  value={Email}
                  onChange={this.onInputChange.bind(this)}
                  onKeyUp={this.onInputKeyUp.bind(this)}
                  autoComplete="email"
                  required
                  autoFocus={true}
                  tabIndex="0"
                  aria-labelledby="login-email"
                  aria-required="true"
                  aria-invalid={showServerError ? 'true' : 'false'}
                  aria-describedby="emailPasswordError"
                />
                <span className="label-error">
                  {EmailError && t(`lp-${EmailError}`)}
                  <LazyLoadImage
                    className={EmailError ? 'errorImg' : 'hiddenImg'}
                    src="/content/images/icons/error.svg"
                    alt=""
                  />
                </span>
              </div>
              <div className="sc-form-row sc-form-row--password position-relative">
                <label id="login-password" className="sc-form__label ">
                  {t('Password')}
                </label>
                <input
                  className="themeFocus menuComponent sc-form__text sc-form__icon-text sc-form__icon--password"
                  data-validate="required"
                  type={hidePassword ? 'password' : ''}
                  id="Password"
                  name="Password"
                  placeholder={t('Password')}
                  value={Password}
                  onChange={this.onInputChange.bind(this)}
                  onKeyUp={this.onInputKeyUp.bind(this)}
                  autoComplete="current-password"
                  required
                  tabIndex="0"
                  aria-labelledby="login-password"
                  aria-required="true"
                  aria-invalid={showServerError ? 'true' : 'false'}
                  aria-describedby="emailPasswordError"
                />
                <div
                  ref={this.eyeRef}
                  tabIndex={-1}
                  className="eye-icon"
                  onClick={this.togglePasswordVisibility.bind(this)}
                >
                  <LazyLoadImage
                    src={`/content/images/icons/${
                      hidePassword ? 'passwordHide' : 'passwordShow'
                    }.png`}
                    width="18px"
                    alt=""
                  />
                </div>
                <span className="label-error">
                  {PasswordError && t(`lp-${PasswordError}`)}
                  <LazyLoadImage
                    className={PasswordError ? 'errorImg' : 'hiddenImg'}
                    src="/content/images/icons/error.svg"
                    alt=""
                  />
                </span>
              </div>

              <div className="sc-form-row sc-form-row--submit">
                {showLoader ? (
                  <img
                    src="/content/images/loader/loading.gif"
                    alt="loader"
                    className="searchBarLoader"
                  />
                ) : showToaster ? (
                  <div className="tosterMessage loginToaster">
                    <div className="tosterContent">
                      <img
                        src="/content/images/header/sc-logo.svg"
                        alt="sc-logo"
                        width="49"
                      />
                      <p>
                        {toasterMessage}
                        <Link to={`/forgot-password?e=${Email}&step=2`}>
                          Change password
                        </Link>
                      </p>
                      <button className="closeToster">
                        <img
                          src="/content/images/icons/close.svg"
                          alt=""
                          onClick={this.hideToaster}
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <button
                      data-testid="submit"
                      className="menuComponent sc-btn-cyan themeFocus"
                      onClick={this.submit.bind(this)}
                    >
                      {t('Log in')}
                    </button>
                    <button
                      className="menuComponent sc-text-btn--cyan login--link-center"
                      type="button"
                      onClick={this.toggleForgotPassword.bind(this)}
                    >
                      {showThankyouMessage
                        ? t('fp-Reset password?')
                        : t('lp-Reset password?')}
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
          {_.isEmpty(this.state.redirectUrl) && (
            <div className="mobile-only">
              <div className="SignUpBottomSection">
                <p className="textCenter">
                  <strong> {t('Not a member?')} </strong>
                  {t('Sign up')} {t('FREE')} {t('to get')}
                  <br />
                  {t(`Extra $${BONUS_PRICE}`)} {t('off your next prescription')}
                </p>
                <p>
                  <Link
                    className="menuComponent"
                    to={_.withLocale(lang, '/signup')}
                  >
                    {t('Sign up link')}
                  </Link>
                </p>
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    setUserPoint: loginResponse => _.setUserPoints(loginResponse, dispatch),
    setUser: loginResponse => _.setUserData(loginResponse, dispatch)
  };
};

LoginForm.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  isFromHeader: PropTypes.bool,
  showHeaderText: PropTypes.func
};
export default withRouter(
  connect(null, mapDispatchToProps)(withTranslation()(LoginForm))
);
